import { Autocomplete, Button, InputAdornment, TextField } from "@mui/material";
import { Box, Grid } from "@mui/system";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";

interface Props {
  /** distinct interface names, deduped by the owning tab */
  searchOptions: string[];
  selectedName: string | null;
  onSelectName: (value: string | null) => void;
  canCreate: boolean;
  onCreate: () => void;
}

/**
 * Search box and the create action above the Interfaces table.
 *
 * This is the one tab with no categorical filter - an interface row carries
 * only its name, its dynamic var and rollup counts - so there is no
 * `InterfacesFilterItems`/`FilterComponent` here, just the Clear Filter button
 * FilterComponent would otherwise have rendered.
 */
const InterfacesFilterCard = ({
  searchOptions,
  selectedName,
  onSelectName,
  canCreate,
  onCreate,
}: Props) => (
  <Box sx={{ padding: "16px 16px 8px" }}>
    <Grid container rowSpacing={2} columnSpacing={3} alignItems="center">
      <Grid size={3}>
        <Autocomplete
          data-tracker="1125"
          sx={{ width: "100%" }}
          options={searchOptions}
          value={selectedName}
          onChange={(_, newValue) => onSelectName(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Interface Name"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ marginLeft: "12px" }} />
                  </InputAdornment>
                ),
              }}
              color="secondary"
            />
          )}
          size="small"
        />
      </Grid>
      <Grid size={6}>
        <Button
          sx={{
            color: "#000000DE",
            "&:hover": { backgroundColor: "rgba(156, 39, 176, 0.04)" },
          }}
          onClick={() => onSelectName(null)}
        >
          Clear Filter
        </Button>
      </Grid>
      <Grid size={3}>
        <Box display="flex" justifyContent="flex-end">
          {canCreate && (
            <Button
              variant="contained"
              color="secondary"
              sx={{ whiteSpace: "nowrap" }}
              onClick={onCreate}
              disabled
            >
              Create new Interface <AddIcon sx={{ width: "20px", ml: "5px" }} />
            </Button>
          )}
        </Box>
      </Grid>
    </Grid>
  </Box>
);

export default InterfacesFilterCard;
